import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-two-step-edit-actions',
  templateUrl: './two-step-edit-actions.component.html',
  styleUrl: './two-step-edit-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIcon],
})
export class TwoStepEditActionsComponent {
  readonly actionsDisabled: InputSignal<boolean> = input.required<boolean>();

  readonly autoRepeatEnabled: InputSignal<boolean> = input<boolean>(false);

  protected readonly save: OutputEmitterRef<void> = output<void>();

  protected readonly saveAndContinue: OutputEmitterRef<void> = output<void>();

  protected readonly cancelEdit: OutputEmitterRef<void> = output<void>();
}
